import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaInfo, MediaSprite } from '../../../types'
import { mediaSpriteFromSource } from '../../../utils/media'

export function useMediaSprite(source: File | string, sourceInfo: MediaInfo | null, maxWidth?: number) {
    const [state, setState] = useState<MediaSprite | null>(null)

    useAsyncEffect(async () => {
        if (!sourceInfo) {
            setState(null)
            return
        }

        const sprite = await mediaSpriteFromSource(source, maxWidth, sourceInfo.fps)

        setState(sprite || null)
    }, [maxWidth, source, sourceInfo])

    return state
}
